import { TextField } from "@mui/material";

const TextComponent = (props) => {
  const { question, multiline, disabled } = props;
  return (
    <>
      <TextField
        id={question._id}
        key={"component" + question._id}
        fullWidth={true}
        minRows={multiline ? 5 : 1}
        multiline={multiline}
        disabled={disabled}
        placeholder={question.tooltip ? question.questiond.tooltip : ""}
        onChange={(event) => {}}
        variant="outlined"
      />
      {question?.questiond?.helpPage !== undefined && (
        <a href="#">
          <div style={{ width: "100%", textAlign: "right" }}>
            {question.helpText}
          </div>
        </a>
      )}
    </>
  );
};
export default TextComponent;
